<template>
     <div id="background-wrapper"  class="block block-pd-sm block-bg-grey-dark block-bg-overlay block-bg-overlay-6 text-center iso-spring-background" data-stellar-background-ratio="0.3">
     <div class="hidden-xs">
      <h2 class="h-xlg h1 m-a-0">
        ISO 9001:2015
      </h2>
      <h3 class="h-lg m-t-0 m-b-lg">
        CERTIFIED
      </h3>
    </div>
    </div>
</template>

<script>
export default {
  name: "HomePageIso"
};
</script>

<style scoped>
.iso-spring-background {
  background-image: url(../assets/img/band-uncropped.jpg);
}
</style>




// WEBPACK FOOTER //
// src/components/HomePageIso.vue